/*
 * ****************************************************************
 * File: Login/index.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Prathik Pai
 *
 * ****************************************************************
 */
import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { useHistory, withRouter } from "react-router-dom";
import Slide from "@material-ui/core/Slide";
import logo from "../../assets/Logo.svg";
import Autocomplete from "@material-ui/lab/Autocomplete";
import audioPlayer from "../../components/audioPlayer";
import {
  Paper,
  TextField,
  Button,
  Toolbar,
  Grid,
  AppBar,
} from "@material-ui/core";
import userIcon from "../../assets/User_Icon.svg";
import ALertIcon from "../../assets/Alert_Icon.svg";
import Avatar from "@material-ui/core/Avatar";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#F1F5F8",
    height: "100vh",
    textAlign: "center",
  },
  logo: {
    width: "251px",
    height: "55px",
  },
  text: {
    fontSize: "22px",
    color: "#314b9f",
    textTransform: "uppercase",
    fontWeight: "bold",
    marginTop: "-10px",
    textAlign: "center",
    marginBottom: "15px",
    letterSpacing: "0px",
    opacity: 1,
    height: "28px",
  },
  userIcon: {
    width: "104px",
    height: "104px",
    background: "#BDC9E3",
    margin: "auto",
    top: "30px",
  },
  paper: {
    maxWidth: "905px",
    height: "452px",
    textAlign: "center",
    margin: "auto",
  },
  paperMain: {
    display: "flex",
    flexDirection: "column",
  },
  userIconText: {
    marginTop: "6vh",
    fontWeight: "bold",
    color: "#414141",
    fontSize: "20px",
  },
  main1: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "row",
    marginTop: "7vh",
  },
  main2: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "row",
  },

  label: {
    fontWeight: "bold",
    color: "#414141",
    margin: "1rem",
    marginLeft: "-4px",
  },
  label1: {
    fontWeight: "bold",
    color: "#414141",
    margin: "1rem",
    marginLeft: "-10px",
  },
  buttonMain: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "row",
    marginTop: "2vh",
  },
  button: {
    background: "#314B9F",
    width: "250px",
    height: "34px",
    justifyContent: "center",
    textAlign: "center",
    margin: "auto",
    color: "#FFFF",
  },
  footer: {
    position: "fixed",
    bottom: "15px",
    padding: "8px",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    minHeight: "3%",
  },
  dialog: {
    display: "flex",
    justifyContent: "center",
    color: "white",
    width: "400px",
    margin: 0,
  },
  isLogged: {
    display: "flex",
    justifyContent: "center",
    color: "white",
    width: "400px",
    margin: 0,
  },
}));

function Copyright() {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      style={{ fontSize: "13px" }}
    >
      {"Copyright © "}
      {new Date().getFullYear()}
      {"."} All Rights Reserved. RADISYS
    </Typography>
  );
}

const getItem = () => {
  let list = localStorage.getItem("list");
  if (list) {
    return JSON.parse(localStorage.getItem("list"));
  } else {
    return [];
  }
};

function Login({
  connect,
  isBrowser,
  test = false,
  loggedValue,
  setLoggedValue,
  engageClient,
}) {
  const firstInputRef = useRef();
  const secondInputRef = useRef();
  const classes = useStyles();
  const [state, setState] = useState({
    username: "",
    identity: "",
  });
  const [browserSupport, setBrowserSupport] = useState(false);
  const [Userstate, setUserstate] = React.useState(getItem());

  const history = useHistory();

  const handlechange = (event) => {
    event.preventDefault();
    if (event.target.name == "username") {
      setState({ ...state, username: event.target.value });
    }
    if (event.target.name == "identity") {
      setState({ ...state, identity: event.target.value.trim() });
    }
  };

  const submit = async () => {
    if (state.username !== "" || state.identity !== "") {
      setUserstate([
        ...Userstate,
        { username: state.username, identity: state.identity },
      ]);
      audioPlayer.play("silent", 0.0);
      audioPlayer.stop("silent");
      await connect(state.username, state.identity);
      await history.push("/home");
    }
  };

  useEffect(() => {
    firstInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (Userstate) {
      const newArrayList = [];
      Userstate.forEach((obj) => {
        if (!newArrayList.some((o) => o.username === obj.username)) {
          newArrayList.push({ ...obj });
        }
      });
      setUserstate(newArrayList);
    }
  }, []);

  React.useEffect(() => {
    localStorage.setItem("list", JSON.stringify(Userstate));
  }, [Userstate]);

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      secondInputRef.current.focus();
    }
  };

  const onChangeModel = (e, newvalue, reason) => {
    if (reason !== "reset") {
      setState({ ...state, username: newvalue });
    } else if (e === null && newvalue !== "") {
      setState({ ...state, username: newvalue });
    }
  };

  const onChangeModelidentity = (e, newvalue, reason) => {
    if (reason !== "reset") {
      setState({ ...state, identity: newvalue });
    } else if (e === null && newvalue !== "") {
      setState({ ...state, identity: newvalue });
    }
  };

  localStorage.setItem("userName", JSON.stringify(state?.username));
  localStorage.setItem("identity", JSON.stringify(state?.identity));

  React.useEffect(() => {
    if (!isBrowser) {
      setBrowserSupport(true);
    }
  }, [isBrowser]);

  return (
    <Grid
      justify="center"
      container
      style={{
        backgroundColor: "whitesmoke",
        height: "100vh",
        textAlign: "center",
        margin: "auto",
      }}
    >
      {test && (
        <div>
          <div data-testid="submit" onClick={submit}></div>
          <div
            data-testid="handleChangeUserName"
            onClick={() =>
              handlechange({
                target: { name: "username", value: "Alex" },
                preventDefault: () => {},
              })
            }
          ></div>
          <div
            data-testid="handleChangeIdentity"
            onClick={() =>
              handlechange({
                target: { name: "identity", value: "99999" },
                preventDefault: () => {},
              })
            }
          ></div>
          <div
            data-testid="onChangeModelCase1"
            onClick={() => onChangeModel(null, null, "change")}
          ></div>
          <div
            data-testid="onChangeModelCase2"
            onClick={() => onChangeModel(null, "something", "reset")}
          ></div>
          <div
            data-testid="onChangeModelidentityCase1"
            onClick={() => onChangeModelidentity(null, null, "change")}
          ></div>
          <div
            data-testid="onChangeModelidentityCase2"
            onClick={() => onChangeModelidentity(null, "something", "reset")}
          ></div>
          <div
            data-testid="handleOnKeyDown "
            onClick={() => handleOnKeyDown({ key: "Enter" })}
          ></div>
        </div>
      )}
      <Grid
        justifyContent="center"
        alignItems="center"
        xs={12}
        md={7}
        lg={9}
        item
        style={{ textAlign: "center", marginTop: "3vh" }}
      >
        <a href="https://www.radisys.com/" rel="noreferrer" target="_blank">
          <img
            data-testid="logo"
            src={logo}
            className={classes.logo}
            alt="logo"
          />
        </a>
        <Typography data-testid="login" className={classes.text}>
          programmable video
        </Typography>
      </Grid>
      <Grid
        xs={12}
        md={6}
        lg={7}
        item
        style={{ margin: "1rem", marginTop: "-2vh" }}
      >
        <Paper elevation={3}>
          <Grid xs={12} md={12} lg={12} item style={{ padding: "25px" }}>
            <Avatar
              style={{
                background: "#BDC9E3",
                margin: "auto",
                width: "104px",
                height: "104px",
                marginTop: "2vh",
              }}
            >
              <img src={userIcon} />
            </Avatar>
            <Typography
              style={{
                marginTop: "3vh",
                fontWeight: "bold",
                color: "#414141",
                fontSize: "20px",
              }}
            >
              Register
            </Typography>
          </Grid>
          <Grid
            xs={12}
            md={12}
            lg={12}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Grid
              xs={12}
              md={7}
              lg={7}
              item
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "left",
                margin: "auto",
              }}
            >
              <Grid xs={12} md={7} lg={7} item>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: "#414141",
                    marginBottom: "-8px",
                  }}
                >
                  User Name
                </Typography>
              </Grid>
              <Grid item>
                <Autocomplete
                  data-testid="username_autofocus"
                  id="username"
                  freeSolo
                  options={Userstate}
                  getOptionLabel={(option) =>
                    option["username"] ? option["username"] : ""
                  }
                  inputValue={state["username"] ? state["username"] : ""}
                  onInputChange={onChangeModel}
                  renderInput={(params) => (
                    <TextField
                      inputRef={firstInputRef}
                      onKeyDown={handleOnKeyDown}
                      {...params}
                      // inputProps={{ "data-testid": "username" }}
                      style={{ width: "250px", height: 32 }}
                      size="small"
                      margin="dense"
                      variant="outlined"
                      placeholder="Enter Name"
                      name="username"
                      onChange={handlechange}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              xs={12}
              md={7}
              lg={7}
              item
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "left",
                margin: "auto",
                marginTop: "2vh",
              }}
            >
              <Grid xs={12} md={7} lg={7} item>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: "#414141",
                    marginBottom: "-8px",
                  }}
                >
                  User ID
                </Typography>
              </Grid>
              <Grid item>
                <Autocomplete
                  data-testid="identity"
                  id="free-solo-demo"
                  freeSolo
                  options={Userstate}
                  getOptionLabel={(option) =>
                    option.identity ? option.identity : ""
                  }
                  inputValue={state.identity ? state.identity : ""}
                  onInputChange={onChangeModelidentity}
                  renderInput={(params) => (
                    <TextField
                      inputProps={{ "data-testid": "identity" }}
                      inputRef={secondInputRef}
                      {...params}
                      style={{ width: "250px", height: 32 }}
                      size="small"
                      margin="dense"
                      variant="outlined"
                      placeholder="Enter Phone Number"
                      name="identity"
                      onChange={handlechange}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              xs={12}
              md={7}
              lg={7}
              item
              style={{
                marginBottom: "5vh",
                marginTop: "2vh",
                justifyContent: "center",
                textAlign: "center",
                margin: "auto",
              }}
            >
              <Button
                data-testid="button"
                style={{
                  background: state.identity === "" ? "lightgrey" : "#314B9F",
                  width: "250px",
                  height: "34px",
                  justifyContent: "center",
                  textAlign: "center",
                  margin: "auto",
                  color: "#FFFF",
                  marginTop: "3vh",
                  marginBottom: "5vh",
                }}
                variant="outlined"
                size="small"
                onClick={submit}
                disabled={state.identity === ""}
              >
                Get Started
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={8} lg={8} style={{ margin: "0.5rem" }}>
        <AppBar
          color="transparent"
          style={{
            height: 60,
            backgroundColor: "#F1F5F8",
            top: "auto",
            bottom: 0,
          }}
          position="fixed"
        >
          <Toolbar style={{ justifyContent: "space-between" }}>
            <Typography color="textSecondary" style={{ fontSize: "13px" }}>
              Support | Contact Us | Terms & Conditions | Privacy statement
            </Typography>

            <Copyright />
          </Toolbar>
        </AppBar>
      </Grid>
      <Grid item xs={12} md={8} lg={8}>
        <Dialog
          classes={{
            paper: classes.dialog,
          }}
          style={{ margin: "0.4rem" }}
          TransitionComponent={Transition}
          open={browserSupport}
          onClose={() => setBrowserSupport(false)}
          aria-labelledby="debug-logs"
          aria-describedby="debug logs contains all events generated by the SDK"
        >
          <DialogContent dividers>
            <Typography
              data-testid="dialog-message"
              style={{
                color: "#314B9F",
                textTransform: "capitalize",
                opacity: 1,
                letterSpacing: "0px",
                fontWeight: "bold",
              }}
            >
              browser not supported
            </Typography>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "2vh",
                }}
              >
                <img
                  src={ALertIcon}
                  alt=""
                  style={{
                    width: "48px",
                    height: "48px",
                    marginTop: "2vh",

                    margin: "1rem",
                  }}
                />
                <p style={{ color: "#737373" }}>
                  WebRTC is not supported on this Browser Please try with
                  another Browser
                </p>
              </div>
              <div
                style={{
                  marginTop: "3vh",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Button
                  style={{
                    width: "100px",
                    height: "34px",
                    margin: "1rem",
                    color: "#314B9F",
                  }}
                  variant="outlined"
                >
                  Ok
                </Button>
                <Button
                  data-testid="exit"
                  onClick={() => setBrowserSupport(false)}
                  style={{
                    width: "100px",
                    height: "34px",
                    background: "#314B9F",
                    color: "#FFFF",
                    margin: "1rem",
                  }}
                  variant="contained"
                >
                  Exit
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </Grid>
    </Grid>
  );
}

Login.propTypes = {
  connect: PropTypes.any,
  test: PropTypes.any,
  setIsBrowser: PropTypes.func,
  isBrowser: PropTypes.bool,
  loggedValue: PropTypes.bool,
  setLoggedValue: PropTypes.func,
  engageClient: PropTypes.any,
};

export default withRouter(Login);
